import { Controller } from "@hotwired/stimulus"

// Submits its form as soon as it connects — the GET bounce page's only JS
// behaviour, turning the button_to fallback into an automatic redirect for
// visitors with JS enabled (see Users::SsoOneloginController). The rendered
// button stays the no-JS fallback.
export default class extends Controller {
  connect() {
    this.element.requestSubmit()
  }
}
